import { memo } from "react";
import Skeleton from "../../components/Skeleton";

function GridCardSkeleton() {
    return (
        <div className="gridcard">
            <div className="flex flex-col">
                <Skeleton height={228} style={{ borderRadius: 0 }} />
                <div className="px-4 mt-2 mb-2 flex justify-between">
                    <Skeleton width={40} height={12} />
                    <Skeleton width={16} height={16} />
                </div>
                <div className="px-4">
                    <Skeleton height={16} className="mb-2" />
                    <hr className="mx-3 my-2" />
                </div>
                <div className="px-4 text-center">
                    <Skeleton width={120} height={20} style={{ margin: "0 auto" }} />
                    <hr className="mx-3 mt-1 my-2" />
                    <div className="px-2 mb-3">
                        <Skeleton height={32} />
                    </div>
                </div>
            </div>
        </div>
    );
}

function DiamondGridSkeleton({ count = 8 }) {
    return (
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 pt-2">
            {Array.from({ length: count }).map((_, i) => (
                <GridCardSkeleton key={i} />
            ))}
        </div>
    );
}

export default memo(DiamondGridSkeleton);
